import * as React from "react";
import styles from "./RoundCheckBox.module.scss";
import classnames from "classnames";

export function RoundCheckbox(props) {
    const { checked, className, onChange, dataTestId, children, style, checkboxStyle } = props;

    return (
        <div
            className={classnames(styles["wrapper"], !onChange && styles["not-clickable"], className)}
            data-test-id={dataTestId}
            onClick={() => {
                onChange && onChange(!checked);
            }}
            style={style}
        >
            {onChange && (
                <div style={checkboxStyle} className={classnames(styles["pickup-method-radio"], checked && styles["selected"])}>
                    <div className={styles["pickup-method-radio-inner"]} />
                </div>
            )}
            {children}
        </div>
    );
}
